import { IS_LOCALHOST } from '@/utils/helpers/constants';

const APR_PREFIX = IS_LOCALHOST ? '/apr-rankings' : '';

export const getAPRPath = (
  pathname: string = '',
  params?: Record<string, string | number | undefined>
) => {
  const base = pathname ? `${APR_PREFIX}${pathname}` : APR_PREFIX || '/';

  if (!params) return base;

  const searchParams = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== '') {
      searchParams.set(key, String(value));
    }
  }
  const query = searchParams.toString();
  return query ? `${base}?${query}` : base;
};
